import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProjectionPaginationDot } from './ProjectionPaginationDot';

const rootStyles = {
  position: 'absolute',
  bottom: 20,
  right: '50%',
  display: 'flex',
  flexDirection: 'row',
  marginRight: `${-54}px`,
};

/**
 * @todo
 * This component has poor quality elements that may even be broken.
 * Future improvement work should address this.
 */
class ProjectionPagination extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event, index) {
    this.props.onChangeIndex(index);
  }

  render() {
    const { index, dots } = this.props;

    const children = [];

    for (let i = 0; i < dots; i++) {
      children.push(
        <ProjectionPaginationDot
          key={i}
          index={i}
          active={i === index}
          onClick={this.handleClick}
        />
      );
    }

    return (
      <div className="demo-pagination" style={rootStyles}>
        {children}
      </div>
    );
  }
}

ProjectionPagination.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
};

export { ProjectionPagination };
